import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const CategoryTypeList = Loadable(
  lazy(() =>
    import("./CategoryType").then(({ CategoryType }) => ({
      default: CategoryType,
    }))
  )
);

export const categoryTypeRoutes = [
  {
    path: "/category-type",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.CUSTOMER]}>
        <CategoryTypeList />
      </AuthorizedRoute>
    ),
  },
];
